// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"1009c18b","787":"413abeff"}[chunkId] + ".chunk.js";
};